import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const postEditLTPlannerMaterial = createApi(`UpdateLTPlannerEditSlice`,"PUT");

const UpdateLTPlannerEditSlice = createSlice({
  name: 'UpdateLTPlannerEditSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postEditLTPlannerMaterial.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postEditLTPlannerMaterial.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postEditLTPlannerMaterial.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default UpdateLTPlannerEditSlice.reducer;